import React, { useEffect } from 'react';
import { createBrowserHistory } from 'history';
import { useLocation } from 'react-router-dom';
import autoMergeLevel1 from 'redux-persist/lib/stateReconciler/hardSet';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import { HelmetProvider } from 'react-helmet-async';
import { createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import rootReducer from './common/reducers';
import './styles/App.css';
import APP from './common/tools/AppRoutes';
// MASTER
import Master from './common/master/master';
import Afk from './common/master/afk';
import { SessionProvider } from './common/master/Context/SessionContext';
import Login from './common/master/Login/login';
// Cargo
import Clients from './views/Clients/Clients';
import Projects from './views/Projects/Projects';
import Caja from './views/EntradaTexto/CajaTexto';
import Table from './views/Reportes/Tablas';
import Boton from './views/Accion/Botones';
import Otros from './views/Otros/ControlesVarios';
import moment from 'moment';
import { Theme } from './styles';
import { ThemeProvider } from 'styled-components';
import ProjectOrderWizard from './views/ProjectOrderWizard/ProjectOrderWizard';

const persistConfig = { key: 'persist:root', storage, stateReconciler: autoMergeLevel1 };
const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = createStore(persistedReducer, applyMiddleware(thunk));
const persistor = persistStore(store);
// const history = createBrowserHistory();
const history = createBrowserHistory({
    basename: '/' // Asegúrate de definir el basename aquí
});

const AnalyticsTracker = () => {
    const location = useLocation();  // Obtén la ubicación actual de la ruta

    useEffect(() => {
        // Asegúrate de que Google Analytics está disponible
        if (window.gtag) {
            window.gtag('event', 'page_view', {
                page_location: window.location.href,  // URL completa
                page_path: location.pathname + location.search,  // Solo la ruta + parámetros de búsqueda
                page_title: document.title,  // Título de la página
            });
        }
    }, [location]);  // Se ejecuta cada vez que cambia la ubicación

    return null;  // No necesitamos renderizar nada
};


const App = () => {
    const helmetContext = {};

    const userData = localStorage.getItem('user');
    useEffect(() => {
        // Verificar si estamos procesando autenticación de Microsoft
        const currentSearch = window.location.search;
        const isMicrosoftAuth = currentSearch.includes('token') ||
            currentSearch.includes('loginCode') ||
            sessionStorage.getItem('msAuthParams') ||
            window.location.pathname !== '/';

        if (userData) {
            const isAuth = JSON.parse(userData);

            // Verifica si ExpirationDate existe y es válido
            if (isAuth.ExpirationDate) {
                const expirationDate = moment(isAuth.ExpirationDate);

                if (expirationDate.isBefore(moment())) {
                    // Si la fecha ha expirado, borra localStorage y redirige a '/'
                    localStorage.clear();
                    if (!isMicrosoftAuth) {
                        history.push('/');
                    }
                    return;
                } else {
                    // Si la fecha sigue vigente, redirigir a HOME solo si no estamos en proceso de auth MS
                    if (!isMicrosoftAuth) {
                        history.push(APP.HOME);
                    }
                    return;
                }
            }
        }

        // Si no hay ExpirationDate (usuario no autenticado), redirigir a '/' solo si no estamos en auth MS
        if (!isMicrosoftAuth) {
            history.push('/');
        }
    }, [userData]);

    return (
        <div className="App">
            <HelmetProvider context={helmetContext}>
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <ThemeProvider theme={Theme}>
                            <Router basename="/">
                                <AnalyticsTracker />
                                <SessionProvider>
                                    <Afk />
                                    <Switch>
                                        <Route exact path={APP.INDEX} history={history} component={(props) => <Master banner footer session={undefined} children={<Login />} />} />
                                        <Route exact path={APP.HOME} history={history} component={(props) => <Master navbar banner footer session children={<Clients />} />} />
                                        <Route exact path={`${APP.HOME}/projects`} history={history} component={(props) => <Master navbar banner footer session children={<Projects />} />} />
                                        <Route exact path={`${APP.HOME}/projects/details`} history={history} component={(props) => <Master navbar banner footer session children={<ProjectOrderWizard />} />} />
                                        {/* <Route exact path={`${APP.HOME}/projects/details/products`} history={history} component={(props) => <Master navbar banner footer session children={<ProductDetails />} />} />
                                        <Route exact path={`${APP.HOME}/projects/details/products/series`} history={history} component={(props) => <Master navbar banner footer session children={<ProductSeries />} />} /> */}
                                        <Route exact path={APP.CAJA} history={history} component={(props) => <Master navbar banner footer session children={<Caja />} />} />
                                        <Route exact path={APP.TABLE} history={history} component={(props) => <Master navbar banner footer session children={<Table />} />} />
                                        <Route exact path={APP.BOTON} history={history} component={(props) => <Master navbar banner footer session children={<Boton />} />} />
                                        <Route exact path={APP.OTROS} history={history} component={(props) => <Master navbar banner footer session children={<Otros />} />} />
                                        <Route exact path={APP.NOTFOUND} history={history} component={(props) => <Master banner footer session={undefined} children={<Login />} />} />
                                    </Switch>
                                </SessionProvider>
                            </Router>
                        </ThemeProvider>
                    </PersistGate>
                </Provider>
            </HelmetProvider>
        </div>
    );
}

export default App;
